import styled from 'styled-components'

export const YouTubeWrapper = styled.iframe`
  margin-top: 25px;
  height: 200px;
  width: 350px;
`
